import { Image } from 'projects/kinetic-angular/src/lib/shared/shared.interface';

export interface KngHeader {
  state: KngHeaderNav;
}
export interface KngHeaderNav {
  state: Array<KngHeaderNavStateItem>;
}
export interface KngHeaderNavStateItem {
  mobilePanelIsOpen: boolean;
  cssClass: string;
  menu: Array<KngHeaderNavMenuOption>;
  minimumAccess?: boolean;
}
export interface KngHeaderNavMenuOption {
  id: string;
  isSelected: boolean;
  url: string;
  label: string;
  iconPath: string;
  hideMenu : boolean;
  altText: string;
  cssClass: string;
  notClickable?: boolean;
  submenu: Array<KngHeaderNavMenuOption>;
  dropdownArrow?: Image;
  locations?: Location[];
}
export interface KngHeaderNavMenuOptionIcon {
  label: string;
  id: string;
}
export interface Location {
  accountName: string;
  locationGRID: string;
  adminId?: boolean;
}

export interface KngHeaderNavOptionSelectOn {
  event: Event;
  selection: KngHeaderNavMenuOption;
}

export interface KngHeaderLogosClicked {
  event: Event;
  selection: Array<KngHeaderNavMenuOption>;
}

export enum CssClass {
  user = 'ui__nav__global__user',
  mobile = 'ui__nav__mobile',
  logos = 'ui__nav__global__icon',
  portal = 'ui__nav__portal',
  global = 'ui__nav__global',
  notification = 'ui__nav__global__notification',
  shop = 'ui__nav__global__shop',
  shopMobile = 'shopMenu',
  skipNav = 'Skip Navigation',
  locationListDropdown = 'ui__nav__location__list__dropdown',
  mobileHeaderLogoRaymond = 'ui__nav__mobile__icon__raymond',
  mobileNotificationRaymond = 'ui__nav__mobile__notification'
}
export interface KnHeaderCustomerState {
  hidden: boolean;
  warningNote: string;
  readOnly: string;
  endSession: string;
  username: string;
}
